import React, { useMemo } from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FullLogoSvg } from 'apps/sigma2-ui/src/components/svg/FullLogo';

export const PublicLayout = ({ children }: { children: React.ReactNode }) => {
  const language = useLanguage();

  return (
    <Spacing
      size="gap-16"
      direction="vertical"
      className="min-h-screen items-center justify-center bg-[#F8F8FB]"
    >
      {children}
      <Spacing
        size="sm"
        direction="vertical"
        className="text-gray-600 items-center"
      >
        <FullLogoSvg />
        <S2Typography
          variant="body-7"
          textColorVariant="gray-600"
          translatedContent={language.copyright()}
        />
      </Spacing>
    </Spacing>
  );
};
